var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkGreyDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dark_grey_-_after_selection",
    "data-name": "Dark grey - after selection",
    transform: "translate(-438 -306)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5562",
    "data-name": "Rectangle 5562",
    width: 20,
    height: 20,
    transform: "translate(438 306)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "trash-can",
    transform: "translate(443 308.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1089_",
    d: "M93.039,91.879l-.323-1.008a.479.479,0,0,0-.453-.34H83.85a.479.479,0,0,0-.453.34l-.323,1.008a.351.351,0,0,0,.321.464h9.322A.351.351,0,0,0,93.039,91.879Z",
    transform: "translate(-83.057 -87.888)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_835_",
    d: "M102.044,190.06a.666.666,0,0,0,.65.609h5.572a.666.666,0,0,0,.65-.609l.994-9.37H101.05Z",
    transform: "translate(-100.508 -175.67)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_831_",
    d: "M196.812,1.421a.416.416,0,0,1,.4-.429h1.358a.416.416,0,0,1,.4.429V2h.922V1.421A1.375,1.375,0,0,0,198.569,0h-1.358a1.375,1.375,0,0,0-1.321,1.421V2h.922Z",
    transform: "translate(-192.89 0)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkGreyDelete);
export default __webpack_public_path__ + "static/media/DarkGrey-Delete.b49dcdf9368183c676311fb70f7f39fe.svg";
export { ForwardRef as ReactComponent };